// Sun Valley : barre de progression des photos qui défilent dans les cartes produit (mobile).
// Élément <sv-carte-defile> rendu par snippets/product-card.liquid ; le CSS est dans sv-charte.css.
// On écrit --sv-avance (0 à 1) sur l'élément, le curseur de la barre glisse en CSS.
if (!customElements.get('sv-carte-defile')) {
  customElements.define('sv-carte-defile', class extends HTMLElement {
    connectedCallback() {
      const piste = this.querySelector('.sv-carte-defile__piste');
      if (!piste || !this.querySelector('.sv-carte-defile__barre')) return;
      let tic = null;
      piste.addEventListener('scroll', () => {
        if (tic) return;
        tic = requestAnimationFrame(() => {
          tic = null;
          const max = piste.scrollWidth - piste.clientWidth;
          this.style.setProperty('--sv-avance', max > 0 ? Math.min(1, Math.max(0, piste.scrollLeft / max)) : 0);
        });
      }, { passive: true });
    }
  });
}
